import Customers from './customers/index.ts'
import Settings from './settings/index.ts'
import GiftsAndBundleServices from './gifts-and-bundle-services.ts'
import Promotion from './promotion/index.ts'
import StatsAndReports from './stats-and-reports.ts'
import BooksyWrapped from './booksy-wrapped.ts'
import Sales from './sales.ts'
import Inventory from './inventory/index.ts'
import InventoryMobile from './inventory/index-mobile.ts'
import Profile from './profile.ts'
import Playground from './playground.ts'
import Staff from './staff.ts'
import TurnTracker from './turn-tracker.ts'
import BooksyWallet from './booksy-wallet.ts'

import { store } from '@/store/index.js'
import { useEppo } from '@/composables/eppo'
import { FEATURE_FLAGS } from '@/lib/consts.ts'

const Business = {
  path: '/:businessId(\\d+)',
  name: 'business',
  meta: {
    loginRequired: true,
    defaultSubroute: () => {
      const turnTrackerEnabled = useEppo().ff(FEATURE_FLAGS.Feature_TurnTracker)
        && store.state.business?.business?.turntracker_enabled

      const hasAccessToTurnTracker = store.getters['identity/isReceptionOrHigher']

      return (turnTrackerEnabled && hasAccessToTurnTracker)
        ? {
          name: 'turn-tracker',
        } : {
          name: 'calendar',
          params: {
            date: 'today',
          },
        }
    },
  },
  component: () => import('@/views/business/index.vue'),
  children: [
    {
      path: 'forbidden',
      name: 'forbidden',
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/403-forbidden.vue'),
    },
    {
      path: 'booksy-awards',
      name: 'booksy-awards',
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/booksy-awards.vue'),
    },
    {
      path: 'calendar',
      name: 'calendar-main',
      meta: {
        hintKey: ['hintFeatureCalendar', 'hintFeatureCalendarLive', 'hintRecommendationsCalendar'],
        defaultSubroute: {
          name: 'calendar',
        },
      },
      component: () => import('@/views/business/calendar/index.vue'),
      children: [
        {
          path: 'settings',
          name: 'calendar-settings',
          meta: {},
          component: () => import('@/views/business/calendar/settings.vue'),
        },
        {
          path: '',
          name: 'calendar',
          meta: {
            // enable toasts w/ notifications
            notifications: true,
          },
          component: () => import('@/views/business/calendar/calendar.vue'),
        },
      ],
    },
    {
      path: 'elearning',
      name: 'elearning',
      component: () => import('@/views/business/elearning.vue'),
    },
    {
      path: 'partner-app/:partnerType',
      name: 'partner-app',
      component: () => import('@/views/business/partner-app.vue'),
    },
    {
      path: 'staffer-blocked-info',
      name: 'staffer-blocked-info',
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/staffer-blocked-info/index.vue'),
    },
    {
      name: 'reports',
      path: 'reports/:path(.*)?',
      redirect: { name: 'stats-and-reports' },
    },
    Sales,
    Customers,
    Inventory,
    InventoryMobile,
    Settings,
    GiftsAndBundleServices,
    Profile,
    Promotion,
    StatsAndReports,
    BooksyWrapped,
    Staff,
    TurnTracker,
    BooksyWallet,
    ...(process.env.NODE_ENV === 'development' ? [Playground] : []),
  ],
}

export default Business
